<template>
  <div>
    <div align="right">
      <el-button type="primary" size="mini" @click="dialogVisible = true">
        Add Ingredient
      </el-button>
    </div>
    <el-dialog title="Add Ingredient" :visible.sync="dialogVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="14rem" label-position="left" @submit.prevent.native="onSubmit">
        <el-form-item label="Ingredient" prop="ingredient">
          <el-select v-model="form.ingredient" placeholder="Select an ingredient" remote filterable no-data-text="No matching ingredients found." :remote-method="onQueryChange">
            <el-option v-for="ingredient in ingredients" :key="ingredient.id" :label="ingredient.title" :value="ingredient.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="Measurement">
          <el-input v-model="form.amount" placeholder="Enter optional amount">
            <el-select v-model="form.unit" slot="append" placeholder="Select unit">
              <el-option v-for="unit in units" :key="unit" :label="unit" :value="unit"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <div>
          <el-checkbox v-model="form.required">required</el-checkbox>
        </div>
        <el-button native-type="submit" type="primary" :loading="loading">
          Save
        </el-button>
        <el-button @click="onCancel">
          Cancel
        </el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      ingredients: [],
      units: [null, 'tbsp', 'tsp', 'mg', 'g', 'ml', 'l', 'lb', 'mm', 'cm', 'cube', 'cup', 'can', 'kg'],
      form: {
        amount: null,
        ingredient: null,
        required: true,
        unit: null,
      },
      rules: {
        'ingredient': [
          { required: true, message: 'Select an ingredient.', trigger: 'blur' },
        ],
      },
    }
  },

  props: {
    stepId: String,
  },

  methods: {
    async onQueryChange(query) {
      if (!query) {
        this.ingredients = []
        return
      }

      try {
        var { data } = await this.$http.get('/ingredients', {
          params: { keyword: query },
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      }

      this.ingredients = data
    },

    onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) {
          return false
        }

        this.loading = true

        try {
          var { data } = await this.$http.post(`/recipe-ingredients`, {
            step_id: this.stepId,
            ...this.form,
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.dialogVisible = false
        this.$refs['form'].resetFields()
        this.ingredients = []
        this.$emit('create')
        this.$message.success(data.message)
      })
    },

    onCancel() {
      this.dialogVisible = false
      this.ingredients = []
      this.$refs['form'].resetFields()
    },
  },
}
</script>

<style scoped>
.el-input .el-select {
  width: 14rem;
}
</style>
